<script setup lang="ts">
const { t } = useI18n();

interface Props {
  imagePath: string;
}

defineProps<Props>();

const emits = defineEmits<(e: "handleClearError") => void>();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center h-screen bg-cover bg-top bg-[url('/errors/error-background.svg')] p-10"
  >
    <div class="flex flex-col justify-center items-center">
      <img :src="imagePath" :alt="t('errorPages.error404.title')" class="mb-4 lg:mb-2.5" >
      <div class="text-center mb-4 lg:mb-7.5">
        <h1
          class="text-white text-3xl xs:text-4xl lg:text-[40px] font-medium block leading-tight ltr:first-letter:uppercase"
        >
          {{ t("errorPages.error404.title") }}
        </h1>
        <!-- A block with its own top margin: as an inline span straight after
             a 40px heading the description collided with its descenders. -->
        <p class="text-white/80 text-sm xs:text-base mt-3 leading-relaxed">
          {{ t("errorPages.error404.desc") }}
        </p>
      </div>
      <UButton
        size="xl"
        class="text-white bg-dark-purple bg-[length:200%_auto] bg-gradient-to-r from-dark-purple to-furious-purple ring-furious-purple"
        @click="emits('handleClearError')"
      >
        {{ t("label.back_to_home") }}
      </UButton>
    </div>
  </div>
</template>
